/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import button from "components/buttons/buttons";
import cmsContent from "components/cms-content/cms-content";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import cardsTextBg from "components/cards-text-bg/cards-text-bg";
import blockParallax from "components/block-parallax/block-parallax";
import heroImage from "imComponents/hero-image/hero-image";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import modal from "imComponents/modal/modal";
import heroSlider from "imComponents/hero-slider/hero-slider";
import textImgVar from "imComponents/text-img-var/text-img-var";
import accordion from "imComponents/accordion/accordion";
import customAccordion from "components/custom-accordion/custom-accordion";
import carouselGallery from "imComponents/carousel-gallery/carousel-gallery";
import boxImage from "components/box-image/box-image";
import smallImgText from "components/small-img-text/small-img-text";
import menu from "components/menu/menu";
import archiveFilters from "components/archive-filters/archive-filters";
import archiveList from "components/archive-list/archive-list";
import cardTextOnBg from "components/cards/card-text-on-bg";
import textIframe from "components/text-iframe/text-iframe";
import centeredText from "components/centered-text/centered-text";
import largeText from "components/large-text/large-text";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
accordion();
initHeader();
modal();
heroSlider();
carouselGallery();
//--------------------------------------------------------------------//
